import { Doc, Id } from "../../../_generated/dataModel";
import { FilterRule, FilterRuleCtx } from "../../../lib/types/filters_types";
import { getTableConfig } from "../../../lib/shared/table_search/helpers";
import {
  getBaseQuery,
  resolveEffectiveScope,
} from "../../../lib/shared/table_search/scope";

// Regla de filtro para plantillas por category y/o isActive.
// Respeta el scope efectivo (masterDataScope) usando la misma query base que el listado por defecto.
export const templateFiltersRule: FilterRule<Doc<"document_templates">> = {
  priority: 3,
  build: async (
    ctx: FilterRuleCtx,
    args: Partial<Omit<Doc<"document_templates">, "_id" | "_creationTime">>,
  ) => {
    const { category, isActive } = args;
    if (category === undefined && isActive === undefined) return undefined;

    const companyId = ctx.userContext.companyId;
    if (!companyId) {
      throw new Error("Usuario no tiene empresa asignada");
    }

    const scope = resolveEffectiveScope(
      getTableConfig("document_templates"),
      ctx.userContext,
    );
    const rows = await getBaseQuery(
      ctx.rawCtx,
      "document_templates",
      companyId,
      ctx.userContext.branchId as Id<"branches"> | undefined,
      scope,
    ).collect();

    return rows.filter(
      (tmpl: Doc<"document_templates">) =>
        (category === undefined || tmpl.category === category) &&
        (isActive === undefined || tmpl.isActive === isActive),
    );
  },
};
